import React from 'react'
import { Form } from 'react-final-form'
import { InputField, DateField, DropdownField, VALIDATORS, Error } from '../../components/Fields'
import { LocationsQuery, MembershipsQuery, getStateName, ipContainer, modalContainer, getRichText, StateProvider } from '../../core'

import './form.scss'

const renderField = ({ label, type, location }, setSuccessLocation, hasValidationErrors) => {
  const name = label.toLowerCase().split(' ').join('_')
  const shared = { name, label }

  if (type === 'Text') {
    return  (
      <InputField
        isRequired
        {...shared}
        hasValidationErrors={hasValidationErrors}
      />
    )
  }

  if (type === 'Date') {
    return  (
      <DateField
        isRequired
        {...shared}
        hasValidationErrors={hasValidationErrors}
      />
    )
  }

  if (type === 'Email') {
    return  (
      <InputField
        validators={[VALIDATORS.email]}
        {...shared}
        hasValidationErrors={hasValidationErrors}
      />
    )
  }

  if (type === 'Phone Number') {
    return  (
      <InputField
        {...shared}
        hasValidationErrors={hasValidationErrors}
        validators={[VALIDATORS.phone]}
      />
    )
  }

  if (type === 'Membership' && location ) {
    return (
      <DropdownField
        options={location.membershipOptions.map(o => ({
          name: o.title,
          value: o.title,
        }))}
        validators={[val => val ? undefined : 'Please select workspace']}
        {...shared}
        hasValidationErrors={hasValidationErrors}
      />
    )
  }

  if (type === 'Membership' && !location ) {
    return (
      <MembershipsQuery
        render={({ data }) => (
          <DropdownField
            options={data.memberships
              .filter(a => !a.hideFromForms)
              .sort((a) => a.hideFromPages ? 1 : -1)
              .map(o => ({
                name: o.title,
                value: o.title,
              }))}
            validators={[val => val ? undefined : 'Please select workspace']}
            {...shared}
            hasValidationErrors={hasValidationErrors}
          />
        )}
      />
    )
  }

  if (type === 'Location') {
    return (
      <LocationsQuery
        render={({ data }) => {
          const filteredLocations = data.locations
            .filter(o => o.address && o.address.state)

          const matches = filteredLocations.filter(o => o.address.state === ipContainer.state.region)

          const locs = filteredLocations

          return (
            <DropdownField
              {...shared}
              hasValidationErrors={hasValidationErrors}
              options={[
                ...locs.map(o => ({
                  name: o.title,
                  value: o.title,
                  subcategory: getStateName(o.address && o.address.state),
                  data: o,
                })),
                { name: 'Undecided', value: 'Undecided' },
              ]}
              validators={[val => val ? undefined : 'Please select location']}
              tab-index={6}
              onChange={(val = {}) => {
                const data = val.data || {}
                const { calendlyId } = data
                const successLocation = calendlyId ? `/#calendly:${calendlyId}` : `/#success`
                setSuccessLocation(successLocation)
              }}
            />
          )}}
      />
    )
  }

  return  (
    <InputField
      {...shared}
      hasValidationErrors={hasValidationErrors}
    />
  )
}

const FormContent = ({ data = {}, context = {} }) => {
  const action = data.action

  const location = context.__typename === 'ContentfulLocation'
    ? context
    : null


  let fields = (data.formFields || []).map(field => ({
    ...field,
    location,
  }))

  const onSubmit = (values) => {
    console.log('submit booking to location', values)
  }

  return (
    <div className="_form-wrapper">
      <div className="_form-anchor" id="book-a-tour" />

      {data.editableContent && <div className="_form-intro">
        {getRichText(data.editableContent)}
      </div>}

      <StateProvider>{(hasErrors, setErrors) => (
        <StateProvider>{(successLocation, setSuccessLocation) => (
          <Form
            onSubmit={onSubmit}
            render={({ 
              handleSubmit, 
              hasValidationErrors,
              errors,
              form,
              submitFailed,
              dirtySinceLastSubmit,
            }) => {
              const submit = (e) => {
                if (hasValidationErrors) {
                  e.preventDefault()
                  setErrors(true)
                  return
                } 
              }
              
              let customAction = action

              try {
                if (successLocation) {
                  const { origin } = window.location
                  const { first_name, last_name } = form.getState().values
                  customAction = `${action}?success_location=${origin}${successLocation}:${first_name}+${last_name}`
                }
              } catch(err) {
                console.warn(err)
              }

              return (
                <form 
                  className='_form' 
                  onSubmit={submit}
                  action={customAction} 
                  method="post"
                  encType="application/x-www-form-urlencoded"
                >
                  <div className='_form-fields'>
                    {fields.map((field, i) => {
                      return (
                        <div className='_form-field' data-type={field.type} key={i}>
                          {renderField(
                            field, 
                            setSuccessLocation, 
                            hasErrors && hasValidationErrors 
                          )}
                        </div>
                      )
                    })}
                  </div>

                  <div className="_form-button-wrapper">
                    <button
                      className="_form-button" 
                      type="submit"
                    >
                      {data.submitText || 'Submit'}
                    </button>

                    {hasErrors
                      && hasValidationErrors 
                      && <Error>Please fix required fields</Error>
                    }
                  </div>
                </form>
              )
            }}
          />
        )}</StateProvider>
      )}</StateProvider>
    </div>
  )

}

export default FormContent